import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../hooks/useAuth';
import { useVerifiedPermissions } from '../../../../hooks/useVerifiedPermissions';
import { getAccountsByOrganization, getOrganizationsByAccount } from '../services/OrganizationAccountsService';

// Get accounts in user's organization
export const useOrganizationAccounts = (organizationId?: string) => {
    const { allowedActions } = useVerifiedPermissions();
    
    const canViewOrgAccounts = allowedActions.includes('accounts:manage:org') || allowedActions.includes('accounts:manage:all');
    
    return useQuery({
        queryKey: ['organizationAccounts', organizationId],
        queryFn: () => getAccountsByOrganization(organizationId!),
        enabled: canViewOrgAccounts && !!organizationId
    });
};

// Get organizations for current user
export const useUserOrganizations = () => {
    const { user } = useAuth();
    
    return useQuery({
        queryKey: ['userOrganizations', user?.userId],
        queryFn: () => getOrganizationsByAccount(user?.userId || ''),
        enabled: !!user?.userId
    });
};